export default __webpack_public_path__ + "static/media/member_tab_icon.1ddac225.svg";